import React, { useState, useEffect, useMemo } from 'react'
import { connect } from 'getstream';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useFeedToken from 'sdk/hooks/useFeedToken'
import StreamContext from 'utils/StreamContext'

type InfoProps = {
  children?: React.ReactNode,
}

type Client = ReturnType<typeof connect>

const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || ''
const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || ''

function StreamContainer({
  children = null,
}: InfoProps) {
  const [client, setClient] = useState<Client | null>(null)
  const { data: authData } = useIsAuth()
  const tokenData = useFeedToken(authData?.user?.id || '')
  const token: string = tokenData?.data || ''

  useEffect(() => {
    if (token) {
      const newClient = connect(
        REACT_APP_STREAM_API_KEY,
        token,
        REACT_APP_STREAM_APP_ID,
      )
      setClient(newClient)
    }
  }, [token])

  const context = useMemo(() => ({
    token: token || '',
    client,
  }), [token, client])

  return (
    <StreamContext.Provider value={context}>
      {children}
    </StreamContext.Provider>
  )
}

export default StreamContainer
